import { useTranslation } from 'react-i18next';
import { SimpleGrid } from '@chakra-ui/react';
import { StatCard } from '@themes/aegix';
import {
  HiUserGroup,
  HiShieldCheck,
  HiExclamationTriangle,
  HiClock,
} from 'react-icons/hi2';
import type { ReunificationEvent } from '../../types/ReunificationTypes';

interface EventDashboardStatsProps {
  events: ReunificationEvent[];
}

export function EventDashboardStats({ events }: EventDashboardStatsProps) {
  const { t } = useTranslation();
  const activeCount = events.length;
  const totalStudents = events.reduce(
    (sum, e) => sum + e.stats.total_students,
    0,
  );
  const totalReunified = events.reduce(
    (sum, e) => sum + e.stats.students_reunified,
    0,
  );
  const totalMissing = events.reduce(
    (sum, e) => sum + e.stats.students_missing,
    0,
  );

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap={4}>
      <StatCard
        label={t('events.stat.events', 'Events')}
        value={activeCount}
        icon={HiClock}
        colorPalette="blue"
        data-e2e='events-active-count'
      />
      <StatCard
        label={t('events.stat.totalStudents', 'Total Students')}
        value={totalStudents}
        icon={HiUserGroup}
        colorPalette="purple"
        data-e2e='students-total-count'
      />
      <StatCard
        label={t('events.stat.reunified', 'Reunified')}
        value={totalReunified}
        icon={HiShieldCheck}
        colorPalette="green"
        data-e2e='students-reunified-count'
      />
      <StatCard
        label={t('events.stat.missing', 'Missing')}
        value={totalMissing}
        icon={HiExclamationTriangle}
        colorPalette={totalMissing > 0 ? 'red' : 'gray'}
        data-e2e='students-missing-count'
      />
    </SimpleGrid>
  );
}
